/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetDocumentSourceRequest = {
  /**
   * The id of the document.
   */
  documentId: string;
  /**
   * An optional partition to scope the request to. If omitted, accounts created after 1/9/2025 will have the request scoped to the default partition, while older accounts will have the request scoped to all partitions. Older accounts may opt in to strict partition scoping by contacting support@ragie.ai. Older accounts using the partitions feature are strongly recommended to scope the request to a partition.
   */
  partition?: string | null | undefined;
};

/** @internal */
export const GetDocumentSourceRequest$inboundSchema: z.ZodType<
  GetDocumentSourceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
  });
});
/** @internal */
export type GetDocumentSourceRequest$Outbound = {
  document_id: string;
  partition?: string | null | undefined;
};

/** @internal */
export const GetDocumentSourceRequest$outboundSchema: z.ZodType<
  GetDocumentSourceRequest$Outbound,
  z.ZodTypeDef,
  GetDocumentSourceRequest
> = z.object({
  documentId: z.string(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
  });
});

export function getDocumentSourceRequestToJSON(
  getDocumentSourceRequest: GetDocumentSourceRequest,
): string {
  return JSON.stringify(
    GetDocumentSourceRequest$outboundSchema.parse(getDocumentSourceRequest),
  );
}
export function getDocumentSourceRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetDocumentSourceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetDocumentSourceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetDocumentSourceRequest' from JSON`,
  );
}
